import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import About from './pages/About';
import Landing from './pages/Landing';
// import Writing from './pages/Writing';
// import TheNextStep from './pages/TheNextStep';

import Header from './components/Header';
// import Footer from './components/Footer';

import './App.css';

const myTheme = getMuiTheme({
  fontFamily: 'Lato, sans-serif',
  palette: {
    primary1Color: "rgb(186,0,32)",
  },
});

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={myTheme}>
        <Router>
          <div>
            <Header />
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route exact path="/About" component={About} />
              <Route component={Landing} />
            </Switch>
          </div>
        </Router>
      </MuiThemeProvider>
    );
  }
}

            // <Route exact path="/writing" component={Writing} />
            // <Route path="/writing/the-next-step" component={TheNextStep} />

export default App;



// WEBPACK FOOTER //
// ./src/App.js